// Layer: Page (UI) – chỉ render JSX, gọi hook domain từ features.
import React from 'react';
import { Row, Col, Alert } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useForgotPassword } from '@/features/auth/useForgotPassword';
import sdtcLogo from '@/assets/sdtc.svg';
import loginIllustration from '@/assets/login.svg';
import mailIcon from '@/assets/mail.svg';
import styles from './ForgotPasswordPage.module.css';

export const ForgotPasswordPage: React.FC = () => {
  const {
    email,
    emailError,
    loading,
    error,
    handleEmailChange,
    handleSubmit,
    handleGoBack,
  } = useForgotPassword();

  return (
    <Row className={styles.container}>
      <Col xs={0} md={14} className={styles.leftColumn}>
        <div className={styles.textContainer}>
          <h1 className={styles.mainTitle}>
            Hệ thống Quản lý Nhân sự Toàn diện
          </h1>
          <p className={styles.subtitle}>
            Nâng cao hiệu quả làm việc, tối ưu quy trình và kết nối con người trong tổ chức của bạn.
          </p>
        </div>
        <div className={styles.imageContainer}>
          <img src={loginIllustration} alt="Login Illustration" className={styles.illustration} />
        </div>
      </Col>

      <Col xs={24} md={10} className={styles.rightColumn}>
        <button
          type="button"
          onClick={handleGoBack}
          className={styles.backButton}
        >
          <ArrowLeftOutlined /> Quay lại
        </button>

        <div className={styles.formContainer}>
          <div className={styles.logoContainer}>
            <img src={sdtcLogo} alt="SDTC Logo" />
          </div>
          <h2 className={styles.formTitle}>
            Quên mật khẩu
          </h2>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              closable
              style={{ marginBottom: 16 }}
            />
          )}

          <form onSubmit={handleSubmit} className={styles.forgotPasswordForm}>
            <div className={styles.formGroup}>
              <label htmlFor="email" className={styles.formLabel}>Email</label>
              <div className={styles.inputWrapper}>
                <img src={mailIcon} alt="Email" className={styles.inputIcon} />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="Nhập email của bạn"
                  autoComplete="email"
                  className={`${styles.customInput} ${emailError ? styles.inputError : ''}`}
                />
              </div>
              {emailError && <span className={styles.errorMessage}>{emailError}</span>}
            </div>

            <button type="submit" disabled={loading} className={styles.submitButton}>
              {loading ? 'Đang gửi...' : 'Gửi liên kết đặt lại'}
            </button>
          </form>
        </div>
      </Col>
    </Row>
  );
};

